import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCommon from "../Restaumatic.PromotionsEngine.Common/index.js";
import * as Restaumatic$dPromotionsEngine$dProductFilter from "../Restaumatic.PromotionsEngine.ProductFilter/index.js";
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const max = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return y; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return x; }
  $runtime.fail();
};
const $$null = /* #__PURE__ */ Data$dFoldable.foldrArray(v => v1 => false)(true);
const isPromotionApplicable = promotion => productItem => {
  if (promotion.conditions.tag === "CartPromotion") { return false; }
  if (promotion.conditions.tag === "ProductPromotion") {
    return Restaumatic$dPromotionsEngine$dProductFilter.all(Restaumatic$dPromotionsEngine$dProductFilter.inProductSingleFilter(productItem))(Data$dRecord.unsafeGet("productFilter")(promotion.conditions._1));
  }
  $runtime.fail();
};
const getSourcesTargetsRepeatableGreedy = dictOrd => {
  const compare = Restaumatic$dPromotionsEngine$dCart$dProductItem.ordProductItem(dictOrd).compare;
  return v => v1 => {
    if (v <= 1) { return Data$dFunctor.arrayMap(productItem => Data$dTuple.$Tuple(productItem, []))(Data$dArray.sortBy(compare)(v1)); }
    const sortedItems = Data$dArray.sortBy(compare)(v1);
    const $0 = Data$dEuclideanRing.intDiv(length(v1))(v);
    const $1 = Data$dArray.reverse(sortedItems);
    return Data$dArray.zipWithImpl(Data$dTuple.Tuple, $0 < 1 ? [] : Data$dArray.sliceImpl(0, $0, $1), Restaumatic$dPromotionsEngine$dCommon.splitEvery(v - 1 | 0)(sortedItems));
  };
};
const getLastEqualItems = dictOrd => items => {
  const revItems = Data$dArray.reverse(items);
  const v = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, revItems, 0);
  if (v.tag === "Just") {
    const $0 = v._1;
    return Data$dArray.span(i => i.productPrice === $0.productPrice)(revItems).init;
  }
  if (v.tag === "Nothing") { return []; }
  $runtime.fail();
};
const getSourcesTargetsNonRepeatableGreedy = dictOrd => {
  const compare = Restaumatic$dPromotionsEngine$dCart$dProductItem.ordProductItem(dictOrd).compare;
  return normReqItems => productItems => {
    const v = Restaumatic$dPromotionsEngine$dCommon.splitAt(normReqItems - 1 | 0)(Data$dArray.sortBy(compare)(productItems));
    return Data$dTuple.$Tuple(v._1, getLastEqualItems(dictOrd)(v._2));
  };
};
const createSingleProductPromotionalItems = dictOrd => {
  const mkTargetItems1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.mkTargetItems(Data$dFoldable.foldableArray)(dictOrd);
  return promotion => assignmentMode => v => Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.mkDefaultPromotionalItem(v._1)(promotion)(assignmentMode)(mkTargetItems1([
    v._2._1.productItemKey
  ]))(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$PromotionalItemSource(
    "SourceProductItems",
    Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dProductItem.productItemKey)(v._2._2)
  ));
};
const createProductPromotionalItemsRepeatable = dictOrd => {
  const getSourcesTargetsRepeatable1 = getSourcesTargetsRepeatableGreedy(dictOrd);
  const createSingleProductPromotionalItems1 = createSingleProductPromotionalItems(dictOrd);
  return requirements => itemId => promotion => assignmentMode => productItems => {
    const distributedProducts = getSourcesTargetsRepeatable1(max(1)(Data$dRecord.unsafeGet("numRequiredItems")(requirements)))(Data$dArray.filterImpl(
      isPromotionApplicable(promotion),
      productItems
    ));
    return Data$dFunctor.arrayMap(createSingleProductPromotionalItems1(promotion)(assignmentMode))(Data$dArray.zipWithImpl(
      Data$dTuple.Tuple,
      Data$dArray.rangeImpl(itemId, itemId + length(distributedProducts) | 0),
      distributedProducts
    ));
  };
};
const createProductPromotionalItemsNonRepeatable = dictOrd => {
  const getSourcesTargetsNonRepeatable1 = getSourcesTargetsNonRepeatableGreedy(dictOrd);
  const mkTargetItems1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.mkTargetItems(Data$dFoldable.foldableArray)(dictOrd);
  return requirements => itemId => promotion => assignmentMode => productItems => {
    const v = getSourcesTargetsNonRepeatable1(max(1)(Data$dRecord.unsafeGet("numRequiredItems")(requirements)))(Data$dArray.filterImpl(
      isPromotionApplicable(promotion),
      productItems
    ));
    const sourceIds = Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dProductItem.productItemKey)(v._1);
    const applicableIds = Data$dFunctor.arrayMap(Restaumatic$dPromotionsEngine$dCart$dProductItem.productItemKey)(v._2);
    if ($$null(applicableIds)) { return []; }
    return [
      Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.mkDefaultPromotionalItem(itemId)(promotion)(assignmentMode)(mkTargetItems1(applicableIds))(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.$PromotionalItemSource(
        "SourceProductItems",
        sourceIds
      ))
    ];
  };
};
const createProductPromotionalItems = dictOrd => {
  const createProductPromotionalItemsRepeatable1 = createProductPromotionalItemsRepeatable(dictOrd);
  const createProductPromotionalItemsNonRepeatable1 = createProductPromotionalItemsNonRepeatable(dictOrd);
  return requirements => {
    if (Data$dRecord.unsafeGet("repeatable")(requirements)) { return createProductPromotionalItemsRepeatable1(requirements); }
    return createProductPromotionalItemsNonRepeatable1(requirements);
  };
};
const distributePromotion = dictOrd => {
  const createProductPromotionalItems1 = createProductPromotionalItems(dictOrd);
  return inputCartData => itemId => promotion => {
    if (promotion.conditions.tag === "CartPromotion") {
      return Data$dTuple.$Tuple(
        itemId + 1 | 0,
        [
          Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.mkDefaultPromotionalItem(itemId)(promotion)(inputCartData.assignmentMode)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.TargetCart)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.NoSource)
        ]
      );
    }
    if (promotion.conditions.tag === "ProductPromotion") {
      const items = createProductPromotionalItems1(promotion.conditions._1)(itemId)(promotion)(inputCartData.assignmentMode)(inputCartData.productItems);
      return Data$dTuple.$Tuple(itemId + length(items) | 0, items);
    }
    $runtime.fail();
  };
};
const genAndAppendPromotionalItems = dictOrd => {
  const distributePromotion1 = distributePromotion(dictOrd);
  return inputCartData => v => promotion => {
    const v1 = distributePromotion1(inputCartData)(v._1)(promotion);
    return Data$dTuple.$Tuple(v1._1, Data$dSemigroup.concatArray(v._2)(v1._2));
  };
};
const distributePromotions = dictOrd => {
  const genAndAppendPromotionalItems1 = genAndAppendPromotionalItems(dictOrd);
  return inputCartData => promotions => Data$dFoldable.foldlArray(genAndAppendPromotionalItems1(inputCartData))(Data$dTuple.$Tuple(1, []))(promotions)._2;
};
export {
  createProductPromotionalItems,
  createProductPromotionalItemsNonRepeatable,
  createProductPromotionalItemsRepeatable,
  createSingleProductPromotionalItems,
  distributePromotion,
  distributePromotions,
  genAndAppendPromotionalItems,
  getLastEqualItems,
  getSourcesTargetsNonRepeatableGreedy,
  getSourcesTargetsRepeatableGreedy,
  isPromotionApplicable,
  length,
  max,
  $$null as null
};
